// Tudás bázis cikk-regiszter. Új cikk felvételéhez: (1) cikk-komponens létrehozása
// ebben a mappában, (2) egy sor felvétele ebbe a tömbbe. Nincs DB-oldal — a cikkek
// listája (és ezzel a fejléc "Tudás bázis" legördülőjének almenüje is) tisztán
// frontend-vezérelt, ahogy a cikksorozat bővül.
import MozgasbanAzElet from './MozgasbanAzElet';
import KarateAzAgynak from './KarateAzAgynak';

const articles = [
    {
        slug: 'mozgasban-az-elet',
        menuLabel: 'Mozgásban az élet',
        title: 'Mozgásban az élet',
        subtitle: 'Mit tesz a testünkkel az aktivitás – és mit a hiánya?',
        summary:
            'Hogyan hat a rendszeres mozgás a szív-érrendszerre, a csontokra és ízületekre, valamint az anyagcserére és hormonháztartásra — és mi történik, ha a mozgás elmarad.',
        coverImage: '/pictures/tudasbazis/mozgasban-az-elet/Pict01.jpeg',
        publishedDate: '2026-08-24',
        Component: MozgasbanAzElet,
    },
    {
        slug: 'karate-az-agynak',
        menuLabel: 'Karate és kognitív képességek',
        title: 'Karate és kognitív képességek',
        subtitle: 'Hogyan élesíti a mozgás az elmét?',
        summary:
            'A BDNF fehérje, a végrehajtó agyi funkciók és a stresszkezelő hormonok — hogyan fejleszti a rendszeres, koordinációt igénylő mozgás (mint a karate) a memóriát, a fókuszt és az érzelmi egyensúlyt.',
        coverImage: '/pictures/tudasbazis/karate-az-agynak/Pict04.jpeg',
        publishedDate: '2026-08-24',
        Component: KarateAzAgynak,
    },
];

export default articles;

export function getArticleBySlug(slug) {
    return articles.find((article) => article.slug === slug);
}
